import React from "react";
import { cn } from "../../lib/utils";

const levelStyles: Record<number, string> = {
  1: "text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight",
  2: "text-3xl md:text-4xl lg:text-5xl font-bold",
  3: "text-2xl md:text-3xl font-semibold",
  4: "text-xl md:text-2xl font-semibold",
  5: "text-lg md:text-xl font-semibold",
};

const colorStyles: Record<string, string> = {
  default: "text-ink",
  muted: "text-gray-500",
  white: "text-white",
  primary: "text-cambridge",
};

const alignStyles: Record<string, string> = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
};

interface HeadingProps {
  level?: 1 | 2 | 3 | 4 | 5;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "p" | "span";
  color?: "default" | "muted" | "white" | "primary";
  align?: "left" | "center" | "right";
  className?: string;
  children: React.ReactNode;
}

export const Heading: React.FC<HeadingProps> = ({
  level = 2,
  as,
  color = "default",
  align,
  className,
  children,
}) => {
  const Tag: React.ElementType = as || `h${level}`;

  return (
    <Tag
      className={cn(
        colorStyles[color],
        levelStyles[level],
        align && alignStyles[align],
        className
      )}
    >
      {children}
    </Tag>
  );
};
